// Form URL utility - returns the pre-configured form submission URL
// This avoids calling get_form_url at runtime, using the pre-configured form instead
const FORM_URL = 'https://readdy.ai/api/form/d9peq6ti2vhsdh2d32tg';

export async function get_form_url(formName: string): Promise<string> {
  // Return the pre-configured form URL
  return FORM_URL;
}